import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './slices/authSlice';
import searchReducer from './slices/searchSlice';
import historyReducer from './slices/historySlice';
import lobbyReducer from './slices/lobbySlice';
import constantsReducer from './slices/constantsSlice';
import mediaReducer from './slices/mediaSlice';
import sportsReducer from './slices/sportsSlice';
import sportsVodReducer from './slices/sportsVodSlice';
import billingReducer from './slices/billingSlice';
import livetvReducer from './slices/livetvSlice';
import screenReducer from './slices/screenSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    search: searchReducer,
    history: historyReducer,
    lobby: lobbyReducer,
    constants: constantsReducer,
    media: mediaReducer,
    sports: sportsReducer,
    sportsVod: sportsVodReducer,
    billing: billingReducer,
    livetv: livetvReducer,
    screen: screenReducer,
  },
});

// In dev (and only in dev) expose the store on window so the ux-bundle-demo
// Playwright script can dispatch synthetic WS events directly into the
// running app without a real second peer. Stripped in production builds via
// the `import.meta.env.DEV` flag — Vite tree-shakes the entire block.
if (typeof window !== 'undefined' && import.meta.env.DEV) {
  (window as unknown as { __cs_store__: typeof store }).__cs_store__ = store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
